import { OpportunityReportsStoreModels } from './opportunityReportsData.state';

export const OPPORTUNITY_REPORTS_REQUEST = '[Reports] opportunity-reports-request';
export const OPPORTUNITY_REPORTS_SUCSSES = '[Reports] opportunity-reports-success';
export const OPPORTUNITY_REPORTS_FAILD = '[Reports] opportunity-reports-faild';

// Actions for Opportunity Reports
export class OpportunityReportsRequestAction {
    readonly type = OPPORTUNITY_REPORTS_REQUEST;
}

  export class OpportunityReportsSuccessAction {
    readonly type = OPPORTUNITY_REPORTS_SUCSSES;

    constructor(public payload?: OpportunityReportsStoreModels){}
  }

  export class OpportunityReportsFaildAction {
    readonly type = OPPORTUNITY_REPORTS_FAILD;

    constructor(public payload?: any){}
  }
